module.exports = __webpack_public_path__ + "img/tu5.1a94e3cf.png";